export function HierarchicalStructure({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_7809_16358)">
          <mask id="mask0_7809_16358" maskUnits="userSpaceOnUse" x="1" y="1" width="16" height="16">
            <path d="M17 1H1V17H17V1Z" fill="white" />
          </mask>
          <g mask="url(#mask0_7809_16358)">
            <path
              d="M9.74016 15.26H8.26683C7.86016 15.26 7.52686 14.9266 7.52686 14.52V13.0466C7.52686 12.64 7.86016 12.3066 8.26683 12.3066H9.74016C10.1468 12.3066 10.4802 12.64 10.4802 13.0466V14.52C10.4802 14.9266 10.1468 15.26 9.74016 15.26Z"
              fill="#82B2C0"
            />
            <path
              d="M12.0596 6.9269H5.9396C4.7796 6.9269 3.84627 5.9869 3.84627 4.83357C3.84627 3.67357 4.78627 2.74023 5.9396 2.74023H12.0596C13.2196 2.74023 14.1529 3.68023 14.1529 4.83357C14.1529 5.99357 13.2129 6.9269 12.0596 6.9269Z"
              fill="#82B2C0"
            />
          </g>
          <path
            d="M9 6.92676V12.3134"
            stroke="#82B2C0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_7809_16358">
            <rect width="16" height="16" fill="white" transform="translate(1 1)" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
}
